import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthResponse, AuthState } from "../../../types/models/auth";

// New type for user profile updates
interface UserProfileUpdate {
  first_name?: string;
  last_name?: string;
}

const initialState: AuthState = {
  user: null,
  accessToken: null,
  refreshToken: null,
  roleId: null,
  roleName: null,
  permissions: [],
  isLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<AuthResponse>) => {
      state.user = {
        id: action.payload.id,
        email: action.payload.email,
        first_name: action.payload.first_name,
        last_name: action.payload.last_name,
        role_id: action.payload.role_id,
        role_name: action.payload.role_name,
        permissions: action.payload.permissions || [],
      };
      state.accessToken = action.payload.access_token;
      state.refreshToken = action.payload.refresh_token || null;
      state.roleId = action.payload.role_id;
      state.roleName = action.payload.role_name || null;
      state.permissions = action.payload.permissions || [];
      state.isLoading = false;

      // Store data in localStorage
      localStorage.setItem("accessToken", action.payload.access_token);
      if (action.payload.refresh_token) {
        localStorage.setItem("refreshToken", action.payload.refresh_token);
      }
      localStorage.setItem("roleId", String(action.payload.role_id));
      localStorage.setItem("roleName", action.payload.role_name || "");
      localStorage.setItem("permissions", JSON.stringify(action.payload.permissions || []));
      // Store user email for easier identification
      localStorage.setItem("email", action.payload.email);
      // Store user object for easier access
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.roleId = null;
      state.roleName = null;
      state.permissions = [];
      state.isLoading = false;

      // Clear localStorage on logout
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("roleId");
      localStorage.removeItem("roleName");
      localStorage.removeItem("permissions");
      localStorage.removeItem("email");
      localStorage.removeItem("user");
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    // New reducer for updating user profile info
    updateUserInfo: (state, action: PayloadAction<UserProfileUpdate>) => {
      if (state.user) {
        // Update user properties
        state.user = {
          ...state.user,
          ...action.payload
        };
        
        // Also update localStorage
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
  },
});

export const { setCredentials, logout, setLoading, updateUserInfo } = authSlice.actions;
export default authSlice.reducer;